import { render, staticRenderFns } from "./ghDialog.vue?vue&type=template&id=64a0d594&scoped=true&"
import script from "./ghDialog.vue?vue&type=script&lang=js&"
export * from "./ghDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0d594",
  null
  
)

export default component.exports